var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomePageBannerUpsell/HomePageBannerUpsellWrapper.jsx";

/* eslint-disable zillow/react/no-danger */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import HomePageBannerUpsell from './HomePageBannerUpsell';
import { NewLaneEvent } from '../../../../../eventing/NewLaneEvent';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
export var HomePageBannerUpsellWrapper = function HomePageBannerUpsellWrapper(_ref) {
  var actionLink = _ref.actionLink,
      actionText = _ref.actionText,
      headlinePrefix = _ref.headlinePrefix,
      headlineSuffix = _ref.headlineSuffix,
      mediaImage = _ref.mediaImage,
      legalText = _ref.legalText,
      description = _ref.description,
      alternativeTheme = _ref.alternativeTheme,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var ref = useOnsiteMessagingImpressionEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  var onClickAction = useYieldCallback(function () {
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData);
    NewLaneEvent(null, newLanePayload);

    if (actionLink) {
      window.open(actionLink, '_self');
    }
  }, [newLaneEventData, additionalClickStreamData, actionLink]);
  var onHoverAction = useCallback(function () {
    var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData);
    NewLaneEvent(null, newLanePayload);
  }, [newLaneEventData, additionalClickStreamData]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HomePageBannerUpsell, {
    buttonText: actionText,
    clickAction: onClickAction,
    hoverAction: onHoverAction,
    description: description,
    headlinePrefix: headlinePrefix,
    headlineSuffix: headlineSuffix,
    mediaImage: mediaImage,
    legalText: legalText,
    alternativeTheme: alternativeTheme,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 13
    }
  }));
};
HomePageBannerUpsellWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The action link for clicking on the component
   */
  actionLink: PropTypes.string.isRequired,

  /**
   * The action text displayed in component
   * */
  actionText: PropTypes.string.isRequired,

  /**
   * The heading prefix displayed in the component.
   * */
  headlinePrefix: PropTypes.string.isRequired,

  /**
   * The description/body text displayed in component.
   * Should not exceed 2 lines when screen width is 1025px.
   * */
  description: PropTypes.string.isRequired,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,
  mediaImage: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),

  /**
   * The heading suffix displayed in the component.
   */
  headlineSuffix: PropTypes.string,

  /**
   * The legal text displayed in the component.
   */
  legalText: PropTypes.string,

  /**
   * boolean to trigger the alternativeTheme
   */
  alternativeTheme: PropTypes.bool
} : {};
HomePageBannerUpsellWrapper.defaultProps = {
  alternativeTheme: false,
  newLaneEventData: {},
  additionalClickStreamData: {}
};